import { ViewerType } from './document-viewer-modal.types';
import isImage from 'is-image';

const IMAGE_EXTENSIONS = ['png', 'jpg', 'jpeg', 'gif', 'webp', 'svg', 'bmp', 'heic', 'apng', 'avif'];
const PDF_EXTENSIONS = ['pdf'];
const TEXT_EXTENSIONS = ['txt', 'csv', 'log', 'md', 'json', 'xml', 'yaml', 'yml'];
const OFFICE_EXTENSIONS = ['doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'pages', 'numbers', 'key'];

export const getFileExtension = (fileName: string): string => {
  const parts = fileName.split('.');
  return parts.length > 1 ? parts[parts.length - 1].toLowerCase() : '';
};

export const getViewerType = (fileName: string): ViewerType => {
  const extension = getFileExtension(fileName);

  if (isImage(fileName) || IMAGE_EXTENSIONS.includes(extension)) {
    return ViewerType.IMAGE;
  }

  if (PDF_EXTENSIONS.includes(extension)) {
    return ViewerType.PDF;
  }

  if (TEXT_EXTENSIONS.includes(extension)) {
    return ViewerType.TEXT;
  }

  if (OFFICE_EXTENSIONS.includes(extension)) {
    return ViewerType.OFFICE;
  }

  return ViewerType.UNSUPPORTED;
};

export const isViewableFile = (fileName: string): boolean => {
  const viewerType = getViewerType(fileName);
  return viewerType !== ViewerType.UNSUPPORTED;
};
